(function () {
	'use strict';

	angular.module('app.setup')
		.directive('pqByCostChart', pqByCostChart);

	pqByCostChart.$inject = ['$window', '$timeout', '$rootScope', 'currencyFormatService', 'percentageFormatService', 
		'numberFormatService', 'fullPageChart', 'leanFilterService', '$experiments'];

	function pqByCostChart($window, $timeout, $rootScope, currencyFormatService, percentageFormatService,
			numberFormatService, fullPageChart, leanFilterService, $experiments) {
		return {
			link: function (scope, elem, attr) {
				var chart;
				var initListener;
				var colors = {
					'dailyCost': 'rgb(5, 132, 226)',
					'cumulativePercentage': 'rgb(255, 155, 48)',
					'dailyUsage': 'rgb(128,128,128)'
				};
				var w = angular.element($window);
				var isSupplierPortal = (globalConfig.user.role === 'Supplier');
				var windowHeight = 0;
				var itemCodes = [];
				var fullItemCodes = [];
				var itemDescriptions = [];
				var itemTypes = [];
				var tooMuchInventoryList = [];
				var dynamicUpdateItemCount = false;
				w.bind('resize', function () {
					windowHeight = fullPageChart.resizeChart('pqByCostChart');
					if (chart)
						chart.resize({
							height: windowHeight
						});
				});

				function init() {
					var hbCont = jQuery('#handlebarContainer').length;
					var supplierPortal = globalConfig.user.role === 'Supplier';
					var gridLoaded = jQuery('#pqByCostChart').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('#handlebarContainer').bind('leftNavChanged', function () {
							windowHeight = fullPageChart.resizeChart('pqByCostChart');
							generateChart();
						});
						windowHeight = fullPageChart.resizeChart('pqByCostChart');
						generateChart();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				var chartFormatters = {
					cumulativePercentage: percentageFormatService.get,
					daysOfCoverage: formatDaysOfCoverageTooltip
				};
				var chartColorMap = {
					dailyCost: 'rgb(45,193,113)',
					dailyCostBad: 'rgb(247,44,37)',
					cumulativePercentage: 'rgb(255,155,48)',
					daysOfCoverage: 'rgb(255,155,48)'
				};

				function chartColors(color, d) {
					var id = d;
					if (typeof d.id !== 'undefined')
						id = d.id;
					if (id === 'dailyCost' && tooMuchInventoryList && tooMuchInventoryList[d.index]) {
						id = 'dailyCostBad';
					}
					return chartColorMap[id];
				}

				function formatDaysOfCoverageTooltip(value) {
					if (value == 180) {
						return '180 Days or More';
					}
					return numberFormatService.get(value);
				}

				function changeConfigToDaysOfCoverage(config) {
					config.data.types = {
						daysOfCoverage: 'line'
					};

					delete config.data.axes.cumulativePercentage;
					config.data.axes.daysOfCoverage = 'y2';

					delete config.data.names.cumulativePercentage;
					config.data.names.daysOfCoverage = 'Days Coverage';

					config.axis.y2.max = getMaxForDaysCoverage(config);
					config.axis.y2.tick.format = formatTickForDaysCoverage;
				}

				function formatTickForDaysCoverage(d) {
					return numberFormatService.get(d) + ' Days';
				}

				function getMaxForDaysCoverage(config) {
					var max = 0;
					for (var i = 0; i < config.data.columns[1].length; i++) {
						if (config.data.columns[1][i] > max)
							max = config.data.columns[1][i];
					}
					return Math.ceil(max / 50) * 50;
				}

				function getFormattedData() {
					var chartData = {};
					chartData.categories = [];
					chartData.columns = [
						['dailyCost']
					];
					if (scope.doDaysOfCoverage) {
						chartData.columns.push(['daysOfCoverage']);
					} else {
						chartData.columns.push(['cumulativePercentage']);
					}
					if (scope.itemCount > scope.rawData.length) {
						scope.itemCount = scope.rawData.length;
						dynamicUpdateItemCount = true;
					} else {
						if (dynamicUpdateItemCount) {
							scope.itemCount = scope.rawData.length < 50 ? scope.rawData.length : 50;
						}
					}
					for (var i = 0; i < scope.itemCount; i++) {
						chartData.categories.push(scope.rawData[i].itemCode);
						chartData.columns[0].push(scope.rawData[i].dailyCost);
						if (scope.doDaysOfCoverage) {
							var daysOfCoverageCapped = (scope.rawData[i].daysOfCoverage > 180) ? 180 : scope.rawData[i].daysOfCoverage;
							// note c3 dont understand undefined
							chartData.columns[1].push(typeof daysOfCoverageCapped === 'undefined' ? null : daysOfCoverageCapped);
						} else {
							chartData.columns[1].push(scope.rawData[i].cumulativePercentage * 100);
						}
						itemCodes[i] = scope.rawData[i].itemCode;
						fullItemCodes[i] = scope.rawData[i].fullItemCode;
						itemDescriptions[i] = scope.rawData[i].itemDescription;
						itemTypes[i] = scope.rawData[i].itemType;
						tooMuchInventoryList[i] = scope.rawData[i].tooMuchInventory == 1 ? true : false;
					}
					return chartData;
				}

				function itemClickedHandler(d) {
					var itemDrilldownScope = angular.element('#itemCtrlDiv').scope();
					itemDrilldownScope.openModal(fullItemCodes[d.x], undefined, 'PQ By Cost', isSupplierPortal, itemCodes[d.x], itemDescriptions[d.x], undefined, undefined, undefined, itemTypes[d.x], leanFilterService.getFactoryList());
				}

				function generateChart() {
					if (!scope.rawData) return;
					var currencySymbol = globalConfig.user.authFacts[leanFilterService.getFactoryList()].currencySymbol;
					var chartData = getFormattedData(scope.rawData, scope.itemCount, scope.doDaysOfCoverage);
					var config = {
						bindto: '#' + elem[0].id,
						point: {
							r: 4
						},
						data: {
							columns: chartData.columns,
							type: 'bar',
							types: {
								cumulativePercentage: 'line'
							},
							axes: {
								dailyCost: 'y',
								cumulativePercentage: 'y2'
							},
							names: {
								dailyCost: 'Daily Cost',
								cumulativePercentage: 'Cumulative Percentage'
							},
							onclick: itemClickedHandler,
							color: chartColors
						},
						axis: {
							x: {
								type: 'category',
								tick: {
									rotate: -60,
									multiline: false,
									culling: {
										max: 100
									},
									outer: false
								},
								height: 120,
								categories: chartData.categories
							},
							y: {
								tick: {
									count: 6,
									format: function (v) {
										return currencyFormatService.get(v, currencySymbol);
									}
								},
								min: 0,
								padding: {
									bottom: 0,
									top: 10
								}
							},
							y2: {
								show: true,
								min: 0,
								max: 100,
								tick: {
									count: 6,
									format: percentageFormatService.get
								},
								padding: {
									bottom: 0,
									top: 0
								}
							}
						},
						grid: {
							y: {
								show: true
							}
						},
						size: {
							height: windowHeight
						},
						tooltip: {
							format: {
								value: function (value, ratio, id) {
									return chartFormatters[id] ? chartFormatters[id](value) : currencyFormatService.get(value, currencySymbol);
								}
							}
						}
					};
					if (scope.doDaysOfCoverage === true) {
						changeConfigToDaysOfCoverage(config);
					}
					chart = c3.generate(config);
					fullPageChart.paintRect(elem[0], chartColorMap.dailyCost, chartColorMap.cumulativePercentage);
				}

				initListener = $rootScope.$on('pqByCostDataReady', function (event, args) {
					if (args && typeof args.itemCountUpdte !== 'undefined' && args.itemCountUpdte) {
						dynamicUpdateItemCount = false;
					}
					init();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart = chart.destroy();
					}
					if (initListener) {
						initListener();
					}
				});
			}
		};
	}
})();
